export default "__VITE_ASSET__apKO44la__"